import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "./EmployeeBalanceRecords.scss";
import "react-toastify/dist/ReactToastify.css";
import AddBalanceForm from "./AddBalanceForm";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import BalanceRecordsTable from "./BalanceRecordsTable";
import RecordsHeader from "./RecordsHeader";
import { fetchBalanceRecords } from "../../slices/employeeBalance";
import { fetchONeUser } from "../../slices/user";
import { useBalanceRecord } from "../../hooks/useBalanceRecord";
import { formatDate } from "../../utilities/dateUtils";
import { fetchUser } from "../../slices/user";
const EmployeeBalanceRecords = ({ userId, disabled }) => {
  const dispatch = useDispatch();
  const [showAddForm, setShowAddForm] = useState(false);
  
  const {
    balanceRecords,
    loading,
    submitting,
    editingRecord,
    showDeleteModal,
    isValueChanged,
    startEditing,
    handleInputChange,
    confirmDelete,
    handleDeleteRecord,
    handleCancelDelete,
    handleUpdateBalance,
    cancelEditing
  } = useBalanceRecord(userId);
  
  useEffect(() => {
    if (userId) {
      dispatch(fetchBalanceRecords(userId));
    }
  }, [userId, dispatch]);

  const handleAddSuccess = () => {
    setShowAddForm(false);
    dispatch(fetchBalanceRecords(userId));
    dispatch(fetchUser());
  };

  return (
    <div className="employee-balance-records">
      {showDeleteModal && (
        <DeleteConfirmationModal 
          onCancel={handleCancelDelete}
          onConfirm={handleDeleteRecord}
          isSubmitting={submitting}
        />
      )}

      <RecordsHeader 
        disabled={disabled}
        showAddForm={showAddForm}
        setShowAddForm={setShowAddForm}
      />

      {showAddForm && (
        <AddBalanceForm 
          userId={userId}
          onSuccess={handleAddSuccess}
          lastBalanceStartDate={balanceRecords.length > 0 ? balanceRecords[balanceRecords.length - 1]?.startDate : null} 
        />
      )}

      {loading ? (
        <p>Loading...</p>
      ) : balanceRecords.length === 0 ? (
        <p>No balance records found.</p>
      ) : (
        <BalanceRecordsTable 
          balanceRecords={balanceRecords}
          disabled={disabled}
          editingRecord={editingRecord}
          submitting={submitting}
          isValueChanged={isValueChanged}
          formatDate={formatDate}
          startEditing={startEditing}
          handleInputChange={handleInputChange}
          handleUpdateBalance={handleUpdateBalance}
          confirmDelete={confirmDelete}
          cancelEditing={cancelEditing}
        />
      )}
    </div>
  );
};

export default EmployeeBalanceRecords; 